
angular.module('trainerWebApp.resources').factory('CreateGroupCtrlResolver',
  ['$q', 'usersResource', 'groupsResource', 'errorHandler', 'Auth', function ($q, usersResource, groupsResource, errorHandler, Auth) {

    return function () {
      var deferred = $q.defer();
      var getUserDefer = $q.defer();
      var getGroupsDefer = $q.defer();

      usersResource.getUsers(function (result) {
        getUserDefer.resolve(result);
      }, errorHandler.defaultServerErrorHandler());

      groupsResource.getGroups(function (result) {
        getGroupsDefer.resolve(result);
      }, errorHandler.defaultServerErrorHandler());

      $q.all([
          getUserDefer.promise, getGroupsDefer.promise, Auth.getRolePromise()]).then(function (values) {
          return deferred.resolve({
            users: values[0],
            groups: values[1]
          });
        });

      return deferred.promise;
    }
  }]
);
